<template>
    <div :class="{
        container: true,
        'page-main-content': true,
        'page-main-content-compressed': currentEnroll && isCompressed(),
    }" v-if="loading">
        <!-- <div class="loading">
      <div class="lds-ripple">
        <div :style="{ borderColor: $theme.primaryColor }"></div>
        <div :style="{ borderColor: $theme.primaryColor }"></div>
      </div>
    </div> -->
        <content-placeholders>
            <content-placeholders-img :class="$theme.darkTheme ? 'loading-dark' : 'loading-light'"
                class="prev-next-placeholder" />
            <content-placeholders-img :class="$theme.darkTheme ? 'loading-dark' : 'loading-light'"
                class="video-placeholder" />
            <content-placeholders-img :class="$theme.darkTheme ? 'loading-dark' : 'loading-light'"
                class="video-info-placeholder" />
            <content-placeholders-text :class="$theme.darkTheme ? 'loading-dark' : 'loading-light'"
                class="class-title-placeholder" :lines="2" />
            <content-placeholders-img :class="$theme.darkTheme ? 'loading-dark' : 'loading-light'"
                class="accordion-image-placeholder" />
        </content-placeholders>
    </div>
    <div :class="{
        'page-main-content': true,
        'page-main-content-compressed': isCompressed(),
    }" :style="[
        $theme.darkTheme
            ? 'border-left-color: #0d0d13'
            : 'background-color: #f2f3f7; border-left-color: #F2F3F7',
        {
            '--primary-color': $theme.primaryColor,
            '--primary-text': $theme.primaryText,
        },
    ]" v-else>
        <div class="box-menu-navigation" :style="$theme.darkTheme ? '' : 'background-color: #ffffff; color: #ff6600'
            " v-show="!inFullscreen &&
                currentLearningObject && (currentLearningObject.previousId || currentLearningObject.nextId)
                ">
            <div class="container box-menu-center">
                <div class="menu-previous" :style="currentLearningObject && currentLearningObject.previousId
                    ? 'cursor:pointer;'
                    : 'cursor:default'
                    " @click="navigatePreviousClass">
                    <template v-if="currentLearningObject && currentLearningObject.previousId">
                        <!-- <img src="@/assets/icons/previous.svg" alt /> -->
                        <IconPrevious />
                        <span :style="$theme.darkTheme ? '' : 'color: #333333'">Anterior</span>
                    </template>
                </div>
                <div class="menu-next" :style="currentLearningObject && currentLearningObject.nextId ? 'cursor:pointer;' : 'cursor:default'
                    " @click="navigateNextClass(false)">
                    <template v-if="currentLearningObject && currentLearningObject.nextId">
                        <span :style="$theme.darkTheme ? '' : 'color: #333333'">Próximo</span>
                        <!-- <img src="@/assets/icons/next.svg" alt /> -->
                        <IconNext />
                    </template>
                </div>
            </div>

            <!-- <NavPrevBt
        hasPreview

        :visible="Boolean(currentLearningObject.previousId)"
        :onClick="navigatePreviousClass"
        :previewImage="currentLearningObject.previousImage"
        :previewTitle="currentLearningObject.previousName"
      />

      <NavNextBt
        hasPreview

        :visible="Boolean(currentLearningObject.nextId)"
        :onClick="navigateNextClass"
        :previewImage="currentLearningObject.nextImage"
        :previewTitle="currentLearningObject.nextName"
      /> -->
        </div>
        <div v-if="!checkCurrentLearningObjectState" class="quiz-result container">
            <div class="row">
                <div class="result-label result-survey">
                    Esta aula ainda não está liberada.
                </div>
            </div>
        </div>

        <div class="container info-title" v-if="currentLearningObject">
            <div class="content-name" :style="$theme.darkTheme ? '' : 'color: #333333'">
                {{ currentLearningObject.title }}
            </div>

            <div class="master-name line-clamp-3" :style="$theme.darkTheme ? '' : 'color: #333333'">
                {{ currentLearningObject.category }}
            </div>
        </div>
        <div v-if="isUnavailableOffline" class="container">
            <OfflineUnavailableNotice />
        </div>

        <div v-if="currentEnroll && currentEnroll.id" class="container">
            <lease-grace-banner :enrollId="currentEnroll.id" />
        </div>

        <div class="player2 container" v-if="checkCurrentLearningObjectState && currentLearningObject.broadcast && !isUnavailableOffline">
            <!-- <NavPrevBt
        centered
        hasPreview
        :visible="Boolean(currentLearningObject.previousId)"
        :onClick="navigatePreviousClass"
        :previewImage="currentLearningObject.previousImage"
        :previewTitle="currentLearningObject.previousName"
      />

      <NavNextBt
        centered
        hasPreview
        :visible="Boolean(currentLearningObject.nextId)"
        :onClick="() => navigateNextClass(false)"
        :previewImage="currentLearningObject.nextImage"
        :previewTitle="currentLearningObject.nextName"
      /> -->

            <!-- Aqui vai o player -->
            <LeaseBlockedPlaceholder
                v-if="isLeaseBlockedForPlayer"
                :mode="currentLeaseState"
                :enrollId="currentEnroll.id" />
            <template v-else>
                <div v-if="localVideoSrc && isOfflineMode"
                    class="offline-badge"
                    :class="$theme.darkTheme ? 'offline-badge--dark' : 'offline-badge--light'"
                    :style="{ color: $theme.primaryColor, borderColor: $theme.primaryColor }">
                    <i class="material-icons">offline_pin</i>
                    <span>Reproduzindo offline</span>
                </div>
                <coremedia-player :mute="devMute" :customerId="currentEnroll.webcastIntegration.applicationId"
                    :customerToken="currentEnroll.webcastIntegration.accessToken" :learningObject="currentLearningObject"
                    :studentEmail="playerStudentEmail" :localSrc="localVideoSrc" :isOffline="isOfflineMode"
                    :offlineResumeFrom="offlineResumePosition" :localSubtitles="localSubtitles"
                    @ended="handleEnded" @ready="coremediaReady($event)" @time="handlePlayerTime"></coremedia-player>
            </template>
        </div>

        <div class="container" v-if="checkCurrentLearningObjectState && currentLearningObject.audio && !isUnavailableOffline">

            <LeaseBlockedPlaceholder
                v-if="isLeaseBlockedForPlayer"
                :mode="currentLeaseState"
                :enrollId="currentEnroll.id" />
            <template v-else>
                <div v-if="localAudioSrc && isOfflineMode"
                    class="offline-badge"
                    :class="$theme.darkTheme ? 'offline-badge--dark' : 'offline-badge--light'"
                    :style="{ color: $theme.primaryColor, borderColor: $theme.primaryColor }">
                    <i class="material-icons">offline_pin</i>
                    <span>Reproduzindo offline</span>
                </div>
                <CustomVideoPlayer
                    ref="audioPlayer"
                    :src="localAudioSrc || currentLearningObject.audio"
                    :poster="currentLearningObject.image || ''"
                    :autoplay="false"
                    :isAudioOnly="!currentLearningObject.image"
                    :primaryColor="$theme.primaryColor"
                    :startAt="audioResumePosition"
                    @ended="handleEnded"
                    @time="handleAudioTime"
                    @progress="handleAudioProgress"
                    @complete="handleAudioComplete"
                />
            </template>
        </div>


        <div class="container" v-if="checkCurrentLearningObjectState && currentLearningObject.pdf && !isUnavailableOffline">
            <div class="flex-right">
                <button  v-if="isIOSChrome" @click="downloadLearningObjectFile()" class="waves-effect waves-light btn" :style="{background: $theme.primaryColor, color: $theme.primaryText}">Baixar</button>
            </div>
            <pdf-viewer :src="getPDFUrl()"></pdf-viewer>
        </div>
        <div class v-if="checkCurrentLearningObjectState && currentLearningObject.forms && !isUnavailableOffline">
            <Quiz :formId="currentLearningObject.forms.id"></Quiz>
        </div>
        <div class="container" v-if="
            checkCurrentLearningObjectState && currentLearningObject.externalContent && !isUnavailableOffline
        ">
            <div class="row">
                <iframe style="min-height: 554px" class="col s12 m12 l12"
                    :src="'//' + currentLearningObject.externalContent.link" frameborder="0"></iframe>
            </div>
        </div>
        <!-- <div
      class="container"
      v-if="checkCurrentLearningObjectState && currentLearningObject.htmlContent"
    >
      <div class="row">
        <div class="html-content" v-html="currentLearningObject.htmlContent.content"></div>
      </div>
    </div>-->
        <div class="box-info container" :style="$theme.darkTheme ? '' : 'background-color: #f2f3f7'" v-show="checkCurrentLearningObjectState &&
            !inFullscreen &&
            !currentLearningObject.forms
            ">
            <div class="html-content" :style="$theme.darkTheme ? '' : 'color: #333333'" v-if="
                checkCurrentLearningObjectState && currentLearningObject.htmlContent
            " v-html="currentLearningObject.htmlContent.content"></div>

            <div class="info-content">
                <div class="content-flex">
                    <!-- O bloco usa v-show, então renderiza mesmo sem dados: o
                         load sai com loading=false e currentEnroll null quando a
                         matrícula não resolve. Sem o guard, o acesso a
                         currentEnroll.id aqui embaixo estoura no render. -->
                    <lesson-rating
                        v-if="!isOfflineMode && currentLearningObject"
                        :learning-object="currentLearningObject" />

                    <!-- No app vira botão, pra os três gestos da linha (avaliar,
                         concluir, baixar) terem o mesmo tipo de alvo. Na web o
                         checkbox continua: é o padrão da tela e o mouse acerta. -->
                    <lesson-complete-button
                        v-if="$isApp && currentEnroll && currentLearningObject"
                        :enroll="currentEnroll"
                        :learning-object="currentLearningObject" />

                    <div v-else-if="currentLearningObject" class="master-status">
                        <label>
              <input type="checkbox" id="btnStatus" class="filled-in" :checked="currentLearningObject.progress == 100"
                @click="setProgress" />
                            <span :style="$theme.darkTheme ? '' : 'color: #333333'">{{
                                currentLearningObject.progress == 100
                                    ? "Concluído"
                                    : "Concluir"
                            }}
                            </span>
                        </label>
                    </div>

                    <lesson-download-button
                        v-if="currentEnroll && currentLearningObject"
                        :enroll-id="currentEnroll.id"
                        :course-id="currentEnroll.courseId"
                        :learning-object="currentLearningObject" />
                </div>

                <div class="content-flex">
          
          <a href="javascript:;" class="content-downloads" :style="$theme.darkTheme ? '' : 'color: #333333'"
            v-if="showFilesShortcut && currentLearningObject.files && currentLearningObject.files.length"
            @click="scrollToFiles">
                        <IconDownload />
                        <p>Arquivos</p>
                        <span class="files-count" :style="{ background: $theme.primaryColor, color: $theme.primaryText }">{{
                            currentLearningObject.files.length
                        }}</span>
                    </a>

                    <!-- <NavPrevBt
        centered
        hasPreview
        :visible="Boolean(currentLearningObject.previousId)"
        :onClick="navigatePreviousClass"
        :previewImage="currentLearningObject.previousImage"
        :previewTitle="currentLearningObject.previousName"
      />
         -->
          <NavPrevBt hasPreview :visible="Boolean(currentLearningObject.previousId)" :onClick="navigatePreviousClass"
            :previewImage="currentLearningObject.previousImage" :previewTitle="currentLearningObject.previousName" />

                    <NavNextBt hasPreview :visible="Boolean(currentLearningObject.nextId)" :onClick="navigateNextClass"
            :previewImage="currentLearningObject.nextImage" :previewTitle="currentLearningObject.nextName" />

                    <!-- <div class="btn-navigation previous">
          <IconPrevious />
          <span>Anterior</span>
        </div>
        <div class="btn-navigation next">
          <span>Próximo</span>
          <IconNext />
        </div> -->
                </div>
            </div>

            <!-- Arquivos da aula -->
            <div class="lesson-files" ref="lessonFiles" v-if="
                currentLearningObject.files && currentLearningObject.files.length
            ">
                <div class="lesson-files-head">
                    <span class="lesson-files-title" :style="$theme.darkTheme ? '' : 'color: #131318'">Arquivos</span>
                    <span class="lesson-files-count">{{ currentLearningObject.files.length }}</span>
                </div>
                <div class="lesson-files-chips">
                    <template v-for="(file, fileIndex) in currentLearningObject.files">
                        <!-- PDF com DRM em alguns navegadores: o link so pode ser aberto por clique do aluno -->
                        <a v-if="file.generatedItemLink" :key="'lf_' + file.id" class="file-chip"
                            :class="{ 'file-chip--light': !$theme.darkTheme }" :href="file.generatedItemLink"
                            target="_blank" rel="noopener" :title="'Abrir ' + file.name">
                            <b class="file-chip-type" :style="{ background: fileTypeColor(file.fileType) }">{{
                                (file.fileType || '').toUpperCase()
                            }}</b>
                            <span class="file-chip-name">Clique para abrir {{ file.name }}</span>
                        </a>
                        <button v-else :key="'lf_' + file.id" type="button" class="file-chip"
                            :class="{ 'file-chip--light': !$theme.darkTheme, 'file-chip--loading': file.loadingItem }"
                            :title="file.name + ' (' + $options.filters.bytes(file.size) + ')'" :disabled="file.loadingItem"
                            @click="downloadFile(file, fileIndex, currentLearningObject, $event.currentTarget)">
                            <b class="file-chip-type" :style="{ background: fileTypeColor(file.fileType) }">{{
                                (file.fileType || '').toUpperCase()
                            }}</b>
                            <span class="file-chip-name">{{ file.name }}</span>
                            <em class="file-chip-meta" v-if="!file.loadingItem">{{ file.size | bytes }}</em>
                            <em class="file-chip-meta" v-else>{{ progressPercent(file) || '...' }}</em>
                            <span class="file-chip-progress" v-if="file.loadingItem"
                                :style="{ width: progressPercent(file) || '0%', background: $theme.primaryColor }"></span>
                        </button>
                    </template>
                </div>
            </div>

            <div :class="{
                'info-details': true,
            }">
                <!-- Informações -->
                <div class="btn-info" ref="lessonTabs">
                    <button class="tablink" :class="{ active: tabIndex == 1 }" :style="tabIndex == 1
                        ? {
                            background: $theme.primaryColor,
                            color: $theme.primaryText,
                        }
                        : $theme.darkTheme
                            ? {
                                color: '#ffffff',
                            }
                            : {
                                color: '#131318',
                            }
                        " @mouseenter="changeColor" @mouseleave="changeColorToOriginal"
                        @click="setActive(1, { $event })" id="defaultOpen" v-if="!currentLearningObject.htmlContent">
                        Informações
                    </button>
                    <!-- Comentários -->
                    <button v-if="enableComments" class="tablink" :class="{ active: tabIndex == 2 }" :style="tabIndex == 2
                        ? {
                            background: $theme.primaryColor,
                            color: $theme.primaryText,
                        }
                        : $theme.darkTheme
                            ? {
                                color: '#ffffff',
                            }
                            : {
                                color: '#131318',
                            }
                        " @mouseenter="changeColor" @mouseleave="changeColorToOriginal"
                        @click="setActive(2, { $event })">
                        Comentários
                    </button>

                  <!-- Inteligência Artificial -->
                  <button
                    v-if="hasAiCapableMedia && enableIA"
                    id="btn-ia"
                    class="tablink"
                    :class="{ active: tabIndex == 3 }"
                    :style="
                      tabIndex == 3
                        ? {
                            background: $theme.primaryColor,
                            color: $theme.primaryText,
                          }
                        : $theme.darkTheme
                        ? {
                            color: '#ffffff',
                          }
                        : {
                            color: '#131318',
                          }
                    "
                    @mouseenter="changeColor"
                    @mouseleave="changeColorToOriginal"
                    @click="setActive(3, { $event })"
                  >
                    <IconAI />
                    IA
                  </button>
                </div>

                <!-- Content Informações -->
        <div v-if="!currentLearningObject.htmlContent" v-show="tabIndex === 1" id="Informacoes" class="tabcontent"
          :style="$theme.darkTheme ? '' : 'background-color: #f2f3f7'">
                    <div class="tabcontent-text" :style="$theme.darkTheme ? '' : 'color: #333333 !important'"
                        v-html="currentLearningObject.description"></div>
                </div>

                <!-- Content Comentários -->
                <div v-if="enableComments" v-show="tabIndex === 2" id="Comentarios" class="tabcontent"
                    :style="$theme.darkTheme ? '' : 'background-color: #f2f3f7'">
                    <div class="tabcontent-text" :style="$theme.darkTheme ? '' : 'color: #333333 !important'">
                        <CommentsBox level="0" first="true" :comments="this.currentLearningObjectComents"
              :studentId="currentUser.studentId" :studentName="currentUser.studentName" :showReplyBoxId="showReplyBoxId"
              :courseId="currentEnroll.courseId" :learningObjectId="currentLearningObject.id"
              :enrollId="this.currentEnroll.id" />
                    </div>
                </div>

                <!-- Content Inteligência Artificial -->
        <div v-if="hasAiCapableMedia && enableIA" v-show="tabIndex === 3" id="IA" class="tabcontent sub-tabcontent"
          :style="$theme.darkTheme ? '' : 'background-color: #f2f3f7'" :class="{
                        'no-transcript':
                            !hasAiCapableMedia || !transcriptionsVisible || !enableSubtitle,
                    }">

                    <!-- BTN ABAS IA -->
                    <!-- Transcrição -->
          <div class="sub-tabcontent-header">
            <button
              class="sub-tablink"
              :class="{ active: tabIndex == 3 && subtabIndex == 4 }"
              @mouseenter="changeColor"
              @mouseleave="changeColorToOriginal"
              @click="subSetActive(4, { $event })"
              :id="transcriptionsVisible ? 'defaultOpen' : ''"
              v-if="hasAiCapableMedia && transcriptionsVisible && enableSubtitle"
              :style="
                subtabIndex == 4
                  ? {
                      background: $theme.primaryColor,
                      color: $theme.primaryText,
                      borderTopColor: $theme.primaryColor,
                    }
                  : $theme.darkTheme
                  ? {
                      color: '#ffffff',
                      borderBottomColor: $theme.primaryColor,
                      borderTopColor: $theme.primaryColor,
                    }
                  : {
                      color: '#131318',
                      borderBottomColor: $theme.primaryColor,
                      borderTopColor: $theme.primaryColor,
                    }
              "
            >
              Transcrição
            </button>

            <!-- Resumo -->
            <button
              class="sub-tablink"
              :id="transcriptionsVisible ? '' : 'defaultOpen'"
              :class="{ active: tabIndex == 3 && subtabIndex == 5 }"
              :style="
                subtabIndex == 5
                  ? {
                      background: $theme.primaryColor,
                      color: $theme.primaryText,
                      borderTopColor: $theme.primaryColor,
                    }
                  : $theme.darkTheme
                  ? {
                      color: '#ffffff',
                      borderTopColor: $theme.primaryColor,
                    }
                  : {
                      color: '#131318',
                      borderTopColor: $theme.primaryColor,
                    }
              "
              @mouseenter="changeColor"
              @mouseleave="changeColorToOriginal"
              @click="subSetActive(5, { $event })"
            >
              Resumo
            </button>

            <!-- Mapa Mental -->
            <button
              id="btn-mapa"
              class="sub-tablink"
              :class="{ active: tabIndex == 3 && subtabIndex == 6 }"
              :style="
                subtabIndex == 6
                  ? {
                      background: $theme.primaryColor,
                      color: $theme.primaryText,
                      borderTopColor: $theme.primaryColor,
                    }
                  : $theme.darkTheme
                  ? {
                      color: '#ffffff',
                      borderTopColor: $theme.primaryColor,
                    }
                  : {
                      color: '#131318',
                      borderTopColor: $theme.primaryColor,
                    }
              "
              @mouseenter="changeColor"
              @mouseleave="changeColorToOriginal"
              @click="subSetActive(6, { $event })"
            >
              Mapa Mental
            </button>

            <!-- Quiz -->
            <button
              id="btn-quiz"
              class="sub-tablink"
              :class="{ active: tabIndex == 3 && subtabIndex == 7 }"
              :style="
                subtabIndex == 7
                  ? {
                      background: $theme.primaryColor,
                      color: $theme.primaryText,
                      borderTopColor: $theme.primaryColor,
                    }
                  : $theme.darkTheme
                  ? {
                      color: '#ffffff',
                      borderTopColor: $theme.primaryColor,
                    }
                  : {
                      color: '#131318',
                      borderTopColor: $theme.primaryColor,
                    }
              "
              @mouseenter="changeColor"
              @mouseleave="changeColorToOriginal"
              @click="subSetActive(7, { $event })"
            >
              Quiz
            </button>
          </div>

                    <!-- BTN ABAS IA -->

                    <!-- Content IA Interno -->

                    <div v-show="subtabIndex === 4 && enableSubtitle" id="Transcricao" class="tabcontent"
                        :style="$theme.darkTheme ? '' : 'background-color: #f2f3f7'">
                        <div class="tabcontent-text" :style="$theme.darkTheme ? '' : 'color: #333333 !important'">
                            <vd-transcript v-slot="{ search, transcripts, currentIndex, seek }"
                @selectedchanged="handleTranscriptSelectedChange" @searchresultindexchanged="handleSearchResultChanged">
                                <div class="transc-box">
                                    <div class="transc-search pesquisa" :style="$theme.darkTheme
                                        ? ''
                                        : 'background-color: #efefef ; color: #333333'
                                        ">
                                        <div class="nav-wrapper search-box">
                                            <form @submit.prevent>
                                                <div class="input-field">
                          <input id="search-trans" type="search" placeholder class="white-text" required :style="$theme.darkTheme
                                                            ? ''
                                                            : 'background-color: #efefef; color: #333333 !important'
                                                            " :value="searchQuery" @input="
                                                                debounceSearch(
                                                                    $event.target.value,
                                                                    search.setText
                                                                )
                                                                " />
                                                    <label class="label-icon" for="search-trans">
                            <i class="material-icons" :style="{ color: $theme.primaryColor }">search</i>
                                                    </label>
                                                </div>
                                            </form>
                                        </div>
                    <div class="search-results" v-if="search.text" :style="$theme.darkTheme ? '' : 'color: #333333'">
                                            {{ search.currentCount }}/{{ search.totalCount }}
                                        </div>
                                    </div>
                                    <div class="transc-clear">
                                        <a href="javascript:;" @click="search.setText(''); searchQuery = ''">
                                            <i class="material-icons" :style="{ color: $theme.primaryColor }">clear</i>
                                        </a>
                                    </div>

                                    <div class="transc-up">
                                        <a href="javascript:;" @click="search.previousResult()">
                      <i class="material-icons" :style="{ color: $theme.primaryColor }">expand_less</i>
                                        </a>
                                    </div>
                                    <div class="transc-down">
                                        <a href="javascript:;" @click="search.nextResult()">
                      <i class="material-icons" :style="{ color: $theme.primaryColor }">expand_more</i>
                                        </a>
                                    </div>
                                </div>
                <div class="tabcontent-text" :style="$theme.darkTheme ? '' : 'color: #333333 !important'">
                  <ul ref="transcripts" class="transcripts" :class="$theme.darkTheme ? 'dark' : 'light'">
                                        <!--
                              -->
                                        <li v-for="(item, index) in transcripts" :key="'transcript' + index"
                                            class="segment" :class="{ current: index == currentIndex }" @click="playAndSeek(item.begin, seek)">
                                            <span class="segment-timestamp">
                                                {{ item.begin | formatTimestamp }}
                                            </span>

                                            <p v-if="item.searchResult">
                        <span v-for="(part, partIndex) in item.parts" :key="'phrase' + index + 'part' + partIndex"
                          :class="{
                                                        filtered:
                                                            part.text.toLowerCase() ==
                                                            search.text.toLowerCase(),
                                                        highlight:
                                                            index == search.currentIndexes.phraseIndex &&
                                                            partIndex == search.currentIndexes.partIndex,
                                                    }">{{ part.text }}</span>
                                            </p>
                                            <p v-else class="segment-text">{{ item.text }}</p>
                                        </li>
                                    </ul>
                                </div>
                            </vd-transcript>
                        </div>
                    </div>

                    <div v-show="subtabIndex === 5" id="Resumo" class="tabcontent"
                        :style="$theme.darkTheme ? '' : 'background-color: #f2f3f7'">
                        <div class="tabcontent-text" :style="$theme.darkTheme ? '' : 'color: #333333 !important'">
                            <template v-if="aiContent && aiContent.shortSummary">
                                <div class="aiTitle">Síntese</div>
                                <p class="aiContent">
                                    {{ aiContent.shortSummary }}
                                </p>
                            </template>
                            <template v-if="aiContent && aiContent.summary">
                                <div class="aiTitle">Resumo</div>
                                <p class="aiContent">
                                    {{ aiContent.summary }}
                                </p>
                            </template>

                            <StudentClassEmptyTabFallback v-if="
                                !aiContent || !(aiContent.shortSummary || aiContent.summary)
                            " />
                        </div>
                    </div>

                    <div v-if="subtabIndex === 6" id="MapaMental" class="tabcontent"
                        :style="$theme.darkTheme ? '' : 'background-color: #f2f3f7'">
                        <div class="tabcontent-text" :style="$theme.darkTheme ? '' : 'color: #333333 !important'">
                            <AiMindMap v-if="aiContent && aiContent.mindMap" :content="aiContent.mindMap" />
                            <StudentClassEmptyTabFallback v-else />
                        </div>
                    </div>

                    <div v-show="subtabIndex === 7" id="Quiz" class="tabcontent"
                        :style="$theme.darkTheme ? '' : 'background-color: #f2f3f7'">
                        <div class="tabcontent-text" :style="$theme.darkTheme ? '' : 'color: #333333 !important'">
                            <AiQuiz v-if="aiContent && aiContent.quiz" :quiz="aiContent.quiz" />
                            <StudentClassEmptyTabFallback v-else />
                        </div>
                    </div>
                    <!-- Content IA Interno -->
                </div>
            </div>
        </div>

        <!-- Box Next-Content -->
        <div class="box-next-content container" v-if="nextLearningObjects.length || recommendations.length" v-show="!inFullscreen"
            :style="$theme.darkTheme ? '' : 'background-color: #f2f3f7'">
            <div class="nextCarousel">
                <Carousel :show-category="true" :items="nextLearningObjects" @click="navigateToClass"
                    :metadata="{ title: 'Próximos conteúdos' }" :recommendations="recommendations" />
            </div>
        </div>
        <!-- <div class="hidden-dot">
      <a href="javascript:;" @click="enableChatBot()">.</a>
    </div> -->

  </div>
</template>

<script>
import Carousel
  from "@/components/Carousel";
import CommentsBox
  from "@/components/CommentsBox";
import recommendationsMixin from "@/mixins/recommendations";
import { parseWebVtt } from '@/utils/webvtt';
import CustomVideoPlayer
  from "@/components/CustomVideoPlayer";
import StudentClassEmptyTabFallback
  from "@/components/LearningObject/ArtificialInteligence/EmptyTabFallback.vue";
import AiMindMap
  from "@/components/LearningObject/ArtificialInteligence/MindMap/index.vue";
import AiQuiz
  from "@/components/LearningObject/ArtificialInteligence/Quiz/index.vue";
import LeaseBlockedModal
  from "@/components/LeaseBlockedModal";
import LeaseBlockedPlaceholder
  from "@/components/LeaseBlockedPlaceholder";
import LeaseGraceBanner
  from "@/components/LeaseGraceBanner";
import LessonCompleteButton
  from "@/components/LessonCompleteButton";
import LessonDownloadButton
  from "@/components/LessonDownloadButton";
import LessonRating
  from "@/components/LessonRating";
import OfflineUnavailableNotice
  from "@/components/OfflineUnavailableNotice";
import PdfViewer
  from "@/components/PdfViewer";
import CoremediaPlayer
  from "@/components/Player.vue";
import Quiz
  from "@/components/Quiz";
import SpinnerWave
  from "@/components/SpinnerWave";
import IconAI
  from "@/components/UI/IconAI";
import IconDownload
  from "@/components/UI/IconDownload";
import IconNext
  from "@/components/UI/IconNext";
import IconPrevious
  from "@/components/UI/IconPrevious";
import NavNextBt
  from "@/components/UI/NavNextBt";
import NavPrevBt
  from "@/components/UI/NavPrevBt";
import {
  formatTimestamp
} from "@/filters/formatTimestamp";
import {
  termsOfUseMixin
} from "@/mixins/termsOfUseMixin";
import {
  setScreenProtection
} from "@/plugins/vxlScreenGuard";
import {
  AuthService
} from "@/services/auth.service";
import {
  ConfigService
} from "@/services/config.service";
import {
  offlineStorage
} from "@/services/offline/offlineStorage";
import {
  offlineEventQueue,
  OfflineEventType
} from "@/services/offlineEventQueue";
import {
  maybeAskPushPermission,
  PROMPT_TRIGGERS
} from "@/services/push/pushPrompt";
import { parseCommentHash } from "@/services/push/pushTarget";
import {
  Capacitor
} from "@capacitor/core";
import M
  from "materialize-css";
import {
  mapGetters,
  mapState
} from "vuex";

var userAgent = navigator.userAgent;
var platform = navigator.platform;
var maxTouchPoints = navigator.maxTouchPoints;
const isIE = /Trident/.test(userAgent);
const isIOS =
    /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent) ||
    (platform === "MacIntel" && maxTouchPoints > 1);
const isIOSChrome = /CriOS/.test(userAgent);

const createObjectURL = (function createObjectURLClosure() {
    // Blob/createObjectURL is not available, falling back to data schema.
    const digits =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

    // eslint-disable-next-line no-shadow
    return function createObjectURL(data, contentType, forceDataSchema = false) {
        if (!forceDataSchema && URL.createObjectURL) {
            const blob = new Blob([data], { type: contentType });
            return URL.createObjectURL(blob);
        }

        let buffer = `data:${contentType};base64,`;
        for (let i = 0, ii = data.length; i < ii; i += 3) {
            const b1 = data[i] & 0xff;
            const b2 = data[i + 1] & 0xff;
            const b3 = data[i + 2] & 0xff;
            const d1 = b1 >> 2,
                d2 = ((b1 & 3) << 4) | (b2 >> 4);
            const d3 = i + 1 < ii ? ((b2 & 0xf) << 2) | (b3 >> 6) : 64;
            const d4 = i + 2 < ii ? b3 & 0x3f : 64;
            buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
        }
        return buffer;
    };
})();

function timeSpanToMs(timeSpan) {
    if (!timeSpan || !/^(\d{1,2}:?){0,4}$/.test(timeSpan)) return 0;

    const [seconds = 0, minutes = 0, hours = 0, days = 0] = [
        ...timeSpan.split(":").map(Number),
    ].reverse();

    return (
        (days * 60 * 60 * 24 + hours * 60 * 60 + minutes * 60 + seconds) * 1000
    );
}

// Deep link para os comentários (#comentarios / #comentario-{id}): a lista chega
// depois da aula, então o foco tenta de novo até ela aparecer (~6 s no máximo com
// id; sem id, só a aba, rola quando a lista chega ou depois de ~1,2 s).
const COMMENT_FOCUS_RETRY_MS = 300;
const COMMENT_FOCUS_MAX_TRIES = 20;
const COMMENT_TAB_MAX_TRIES = 4;

export default {
    name: "StudentClass",
    mixins: [termsOfUseMixin, recommendationsMixin],
    components: {
        StudentClassEmptyTabFallback,
        Carousel,
        CoremediaPlayer,
        CommentsBox,
        OfflineUnavailableNotice,
        CustomVideoPlayer,
        PdfViewer,
        Quiz,
        SpinnerWave,
        IconNext,
        IconPrevious,
        IconDownload,
        IconAI,
        NavPrevBt,
        NavNextBt,
        AiQuiz,
        AiMindMap,
        LeaseBlockedModal,
        LeaseBlockedPlaceholder,
        LessonRating,
        LessonDownloadButton,
        LessonCompleteButton,
        LeaseGraceBanner,
    },
    data() {
        return {
            // Decisão local-vs-online CONGELADA na abertura da aula (watcher de
            // currentLoDownloadState). Sem o congelamento, o download concluir
            // com o aluno assistindo flipava o localVideoSrc na hora → playerKey
            // muda → player destruído e recriado no meio da reprodução (blink) —
            // e um toast existia só pra explicar a piscada. Baixou durante a
            // exibição = continua online até o fim; a cópia local vale na
            // PRÓXIMA abertura, como nas plataformas de streaming.
            sessionLocalAllowed: false,
            tabIndex: 1,
            subtabIndex: 4,
            commentFocus: null,
            loading: true,
            showReplyBoxId: 0,
            transcriptionsVisible: false,
            devMute: process.env.VUE_APP_DEVMUTE == "true",
            previousPath: null,
            activeDownloads: [],
            // Atalho "Arquivos" da barra de acoes (rola ate o bloco de arquivos).
            // Oculto por enquanto: o bloco ja fica visivel logo abaixo.
            showFilesShortcut: false,
            isIOSChrome: isIOSChrome,
            searchQuery: "",
            searchTimeout: null,
            lastReportedProgress: 0,
            // Incrementado por um timer (mounted) pra forçar a reavaliação
            // periódica do lease — playableState compara com Date.now(), que
            // não é dep reativa; sem isto a expiração por tempo não atualizaria
            // a UI com a tela parada.
            leaseTick: 0,
            courseSettings: {
                enableChatBot: false,
                enableIAContent: false,
                enableSubtitles: false
            }
        };
    },
    async mounted() {
        this.load();
        window.addEventListener("source-click", this.navigateToClassFromBubble);
        this.enableScreenGuard();
        // Tick pra reavaliar o lease por tempo (ver data.leaseTick). 3min basta:
        // o lease dura dias e o gate nativo já corta o playback na hora.
        this._leaseTimer = setInterval(() => { this.leaseTick++; }, 3 * 60 * 1000);
    },
    beforeRouteLeave(to, from, next) {
        window.removeEventListener("source-click", this.navigateToClassFromBubble);
        this.disableScreenGuard();
        next();
    },
    destroyed() {
        // Rede de segurança: se a tela for destruída por um caminho que não passa
        // pelo beforeRouteLeave (ex.: keep-alive/remount), garante que a proteção
        // de tela seja desligada — senão telas não-aula ficariam protegidas.
        this.disableScreenGuard();
        if (this._leaseTimer) { clearInterval(this._leaseTimer); this._leaseTimer = null; }
        clearTimeout(this._commentFocusTimer);
    },
    watch: {
        // Congela a decisão local-vs-online no momento em que a aula ABRE.
        // Download que conclui com a aula em exibição NÃO troca a fonte (nem
        // avisa): o flip do localVideoSrc mudava a playerKey e recriava o
        // player no meio da reprodução. O ícone de download completando é o
        // único sinal — a cópia local assume na próxima abertura da aula.
        currentLoDownloadState: {
            immediate: true,
            handler (newVal, oldVal) {
                if (!newVal) return;
                if (!oldVal || newVal.loId !== oldVal.loId) {
                    this.sessionLocalAllowed = newVal.status === 'downloaded';
                }
            }
        },
        // Destrava o congelamento quando a rede cai no meio da exibição: com
        // cópia local disponível, trocar pra ela é o que salva a sessão (a
        // fonte online só ia estagnar). O blink aqui é aceitável. Não volta
        // pra online quando a rede retorna — local toca normalmente online, e
        // flipar de volta seria um segundo blink gratuito.
        isOfflineMode (offline) {
            if (!offline || this.sessionLocalAllowed) return;
            const enrollId = this.currentEnroll && this.currentEnroll.id;
            const loId = this.currentLearningObject && this.currentLearningObject.id;
            if (!enrollId || !loId) return;
            if (this.getLearningObjectStatus(enrollId, loId) === 'downloaded') {
                this.sessionLocalAllowed = true;
            }
        },
        currentEnroll: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.enableChatBot();
                }
            },
        },
        "$route.path": function () {
            this.load();
        },
        "$route.query.time": function () { },
        "search.text": (text) => {
            this.searchQuery = text;
        },
        "$route.hash": {
            handler: function (hash) {
                // `#comentarios` / `#comentario-{id}` (toque no push de resposta, sino);
                // qualquer outro hash é o salto de tempo do player.
                const comment = parseCommentHash(hash);
                if (comment) this.focusComments(comment.commentId);
                else this.seekToTime(hash);
            },
            immediate: true,
        },
        currentLearningObjectComents() {
            if (this.commentFocus) this.commentFocus.commentsArrived = true;
            this.tryFocusComment();
        },
        enableComments() {
            this.tryFocusComment();
        },
        currentLeaseState: {
            handler (state) {
                this.maybeOpenLeaseModal(state);
            },
            immediate: true
        },
    },
    computed: {
        ...mapState({
            inFullscreen: (state) => state.enroll.inFullscreen,
            config: (state) => state.config,
            currentEnroll: (state) => state.enroll.current,
            currentUser: (state) => state.user.currentUser,
            currentLearningObject: (state) => state.enroll.currentLearningObject,
            learningObjects: (state) => state.enroll.currentLearningObjects,
            currentLearningObjectComents: (state) => state.comment.comments,
            drmConfig: (state) => state.learningObject.drm,
            sidenavIsOpen: (state) => state.config.sidenavIsOpen,
            storedAiContent: (state) => state.learningObject.aiContent,
            storedAiContentLoId: (state) => state.learningObject.aiContentLoId,
            learningObjectsEnrolls: (state) =>
                state.shopWindow.learningObjectsEnrolls,
        }),

        ...mapGetters({
            isDesktop: "dom/isDesktop",
            isConnected: "dom/isConnected",
            getLearningObjectStatus: "download/getLearningObjectStatus",
            getLocalManifestUrl: "download/getLocalManifestUrl",
            getLocalPosition: "download/getLocalPosition",
            getLocalPositionUpdatedAt: "download/getLocalPositionUpdatedAt",
        }),
        playerStudentEmail () {
            // O bundle coremedia usa este e-mail em `GET vdplayer/v2/users/{email}/check`.
            // Vazio vira `/users//check` → 404 e o init do player nunca resolve
            // (Story-5449). Fallback: claim `studentMail` do JWT — existe mesmo
            // quando o GET /students ainda não populou o currentUser.
            if (this.currentUser && this.currentUser.email) return this.currentUser.email;
            // Obs.: este ramo lê sessionStorage (não reativo) — o computed só
            // reavalia quando currentUser mudar.
            try {
                return AuthService.getUserData().studentMail || "";
            } catch (e) {
                console.warn('[StudentClass] playerStudentEmail sem fonte (Story-5449):', e && e.message);
                return "";
            }
        },
        offlineResumePosition () {
            // Restaura posição local quando está tocando fonte LOCAL. Antes só
            // funcionava offline: user que assistiu uma aula baixada com app
            // online não tinha resume preservado ao voltar offline.
            if (!this.localVideoSrc) return 0;
            const enrollId = this.currentEnroll && this.currentEnroll.id;
            const loId = this.currentLearningObject && this.currentLearningObject.id;
            // Online: ignora estimativas (updatedAt === 0) pra não sobrepor o
            // resume nativo/backend, mais preciso. Offline usa qualquer posição.
            if (!this.isOfflineMode && this.getLocalPositionUpdatedAt(enrollId, loId) === 0) return 0;
            return this.getLocalPosition(enrollId, loId) || 0;
        },
        isOfflineMode () {
            return Capacitor.isNativePlatform() && !this.isConnected;
        },
        isUnavailableOffline () {
            if (!this.isOfflineMode) return false;
            const lo = this.currentLearningObject;
            if (!lo) return false;

            // Quiz (forms) e conteúdo externo (iframe) dependem 100% de rede e
            // NÃO são baixáveis — offline mostram o card "indisponível" em vez de
            // travar (quiz no spinner eterno, iframe quebrado). htmlContent fica
            // de fora: vive no JSON cacheado e renderiza offline.
            if (lo.forms || lo.externalContent) return true;

            // Vídeo/PDF/áudio: indisponível só se NÃO baixado. Áudio hoje nunca é
            // baixado (sem branch no downloadLearningObject) → sempre true offline,
            // mostrando o card em vez de um player puxando URL HTTP que falha.
            // Quando download de áudio existir, o status 'downloaded' já cobre.
            if (!lo.broadcast && !lo.pdf && !lo.audio) return false;
            const enrollId = this.currentEnroll && this.currentEnroll.id;
            return this.getLearningObjectStatus(enrollId, lo.id) !== 'downloaded';
        },
        localVideoSrc () {
            const isNative = Capacitor.isNativePlatform();
            const hasBroadcast = !!(this.currentLearningObject && this.currentLearningObject.broadcast);
            const enrollId = this.currentEnroll && this.currentEnroll.id;
            const loId = this.currentLearningObject && this.currentLearningObject.id;
            const status = this.getLearningObjectStatus(enrollId, loId);
            const localUrl = this.getLocalManifestUrl(enrollId, loId);
            if (!isNative || !hasBroadcast || status !== 'downloaded') return null;
            // Fonte congelada por sessão de aula: baixou DURANTE a exibição →
            // segue online até a próxima abertura (ver watcher de
            // currentLoDownloadState). Evita recriar o player em pleno play.
            if (!this.sessionLocalAllowed) return null;
            // Lease gate: 'valid' e 'grace' liberam o player; outros estados
            // (expired/revoked/unknown) seguram. Watcher logo abaixo abre o
            // modal apropriado pra avisar o user.
            if (!this.$store.getters['lease/isEnrollPlayable'](enrollId)) return null;
            return localUrl;
        },
        // Legendas CC locais para o player quando a fonte é local. Deriva do
        // localVideoSrc (herda os gates: downloaded + sessionLocalAllowed +
        // lease) e do índice gravado pelo prefetchSubtitles no download. O src
        // aponta pro .vtt no MESMO diretório do manifest — string replace em
        // vez de Filesystem.getUri porque computed precisa ser síncrono (o
        // vd-coremedia lê props no created(), remontado pela playerKey).
        // SEM gate de enableSubtitle: paridade com o online, onde o bundle
        // sempre anexa as tracks que o /info devolver.
        localSubtitles () {
            if (!this.localVideoSrc) return null;
            const enrollId = this.currentEnroll && this.currentEnroll.id;
            const loId = this.currentLearningObject && this.currentLearningObject.id;
            const list = this.$store.getters['download/getLocalSubtitles'](enrollId, loId);
            if (!Array.isArray(list) || !list.length) return null;
            const base = this.localVideoSrc.replace(/manifest\.m3u8.*$/, '');
            return list.map(s => ({
                src: base + s.filename,
                srclang: s.sigla || '',
                label: s.nome || s.sigla || 'Legenda'
            }));
        },
        // Fonte local do áudio quando offline + baixado (mirror do getPDFUrl).
        // Online devolve null → o template cai pra currentLearningObject.audio (URL remota).
        localAudioSrc () {
            if (!this.isOfflineMode) return null;
            const enrollId = this.currentEnroll && this.currentEnroll.id;
            const loId = this.currentLearningObject && this.currentLearningObject.id;
            if (this.getLearningObjectStatus(enrollId, loId) !== 'downloaded') return null;
            // Lease gate (igual ao localVideoSrc): áudio é plano (sem cifragem) → o lease é o
            // único controle de acesso offline; sem isso, matrícula revogada ainda tocaria.
            if (!this.$store.getters['lease/isEnrollPlayable'](enrollId)) return null;
            return this.getLocalManifestUrl(enrollId, loId) || null;
        },
        // Resume de áudio baixado (mirror do offlineResumePosition do vídeo): a posição
        // local salva por handleAudioTime, passada ao CustomVideoPlayer via :startAt.
        audioResumePosition () {
            const enrollId = this.currentEnroll && this.currentEnroll.id;
            const loId = this.currentLearningObject && this.currentLearningObject.id;
            if (!enrollId || !loId) return 0;
            if (this.getLearningObjectStatus(enrollId, loId) !== 'downloaded') return 0;
            return this.getLocalPosition(enrollId, loId) || 0;
        },
        // Par {loId, status} da aula ABERTA. Watchado acima pra congelar a
        // decisão local-vs-online por sessão de aula (sessionLocalAllowed).
        // Precisa carregar o loId junto: sem ele, navegar de uma aula 'idle'
        // para uma já baixada não seria distinguível de uma conclusão de
        // download da MESMA aula — e o congelamento pegaria o valor errado.
        currentLoDownloadState () {
            const enrollId = this.currentEnroll && this.currentEnroll.id;
            const loId = this.currentLearningObject && this.currentLearningObject.id;
            if (!enrollId || !loId) return null;
            return { loId, status: this.getLearningObjectStatus(enrollId, loId) };
        },
        // Estado de lease do enroll atual. Usado pelo banner de grace e pelo
        // watcher que dispara o modal de bloqueio.
        currentLeaseState () {
            this.leaseTick; // dep reativa: força reavaliação periódica (playableState usa Date.now())
            const enrollId = this.currentEnroll && this.currentEnroll.id;
            if (!enrollId) return 'valid';
            return this.$store.getters['lease/playableState'](enrollId);
        },
        // True quando a aula ATUAL está baixada e o lease bloqueia o playback.
        // Nesse estado o localVideoSrc/localAudioSrc é null (chave AES negada
        // nativamente) → o player viraria um "fantasma" que não carrega. O
        // template mostra o LeaseBlockedPlaceholder no lugar. Só vale pra LO
        // baixado: aula não-baixada cai no fluxo online/OfflineUnavailableNotice.
        // Deriva de currentLeaseState pra herdar a dep do leaseTick.
        isLeaseBlockedForPlayer () {
            const enrollId = this.currentEnroll && this.currentEnroll.id;
            const loId = this.currentLearningObject && this.currentLearningObject.id;
            if (!enrollId || !loId) return false;
            if (this.getLearningObjectStatus(enrollId, loId) !== 'downloaded') return false;
            const st = this.currentLeaseState;
            return st !== 'valid' && st !== 'grace';
        },
        checkCurrentLearningObjectState() {

            if (!this.currentLearningObject) return false;
            if (this.currentLearningObject.state == "Unpublished") return false;
            if (
                this.currentLearningObject.state == "Scheduled" &&
                this.currentLearningObject.releasedDate
            )
                return false;
            return true;
        },
        nextLearningObjects() {
            if (!this.currentLearningObject) return {};

            const structureType = this.currentEnroll.structureType.toLowerCase();

            const currentLearningObjectIndex = this.learningObjects
                .map((lo) => lo.id)
                .indexOf(this.currentLearningObject.id);

            var nextLearningObjects = [];

            for (
                var i = currentLearningObjectIndex + 1;
                i < this.learningObjects.length;
                i++
            ) {
                nextLearningObjects.push(this.learningObjects[i]);

                if (nextLearningObjects.length > 9) break;
            }

            return nextLearningObjects;
        },
        enableComments() {
            if (!this.currentEnroll) return false;
            return this.currentEnroll.settings.enableComments;
        },
        enableSubtitle() {
            if (!this.currentEnroll) return false;
            // Verifica a configuração do curso primeiro
            if (!this.courseSettings.enableSubtitles) return false;
            return this.currentEnroll.settings.subtitleType;
        },
        // Só entrega a IA se ela for da aula que está na tela. String() dos dois
        // lados porque a rota devolve o id como string e o grid como número — o
        // mesmo motivo pelo qual o setCurrentLearningObject compara com `==`.
        // Comparar estrito aqui esvaziaria a aba para todo mundo.
        aiContent() {
            const loId = this.currentLearningObject && this.currentLearningObject.id;
            if (loId == null || this.storedAiContentLoId == null) return null;
            return String(this.storedAiContentLoId) === String(loId) ? this.storedAiContent : null;
        },
        enableIA() {
            if (!this.currentEnroll) return false;
            // Verifica a configuração do curso primeiro
            if (!this.courseSettings.enableIAContent) return false;
            return this.currentEnroll.settings.enableIA;
        },
        /**
         * Aulas cujo conteúdo rende material de IA: as que têm fala transcrita.
         *
         * Story-2499: era `currentLearningObject.broadcast` direto, o que restringia a aba
         * de IA a vídeo. Áudio passou a ter transcrição própria, gravada no EAD, e com ela
         * resumo, mapa mental e quiz — que aliás já vinham sendo buscados para toda aula
         * pelo getAI; só a UI estava escondida.
         */
        /**
         * Story-2499: a aula corrente é de áudio.
         *
         * Discrimina pelo TIPO, não pela existência de `$refs.audioPlayer`. O ref não
         * serve como discriminador por dois motivos: `broadcast` e `audio` são campos
         * independentes (nada garante que sejam mutuamente exclusivos), e o watcher de
         * `$route.hash` roda antes do render watcher — nesse instante o ref ainda aponta
         * para o player da aula anterior, então um deep-link de áudio para vídeo tocaria
         * o áudio velho em vez de posicionar o vídeo.
         */
        isAudioLesson() {
            return !!(this.currentLearningObject && this.currentLearningObject.audio);
        },
        hasAiCapableMedia() {
            if (!this.currentLearningObject) return false;

            return !!(this.currentLearningObject.broadcast || this.currentLearningObject.audio);
        },
    },
    methods: {
        enableScreenGuard () {
            // setScreenProtection (não o plugin direto): respeita o gate de build
            // VUE_APP_ALLOW_SCREEN_CAPTURE, usado nos builds de teste interno.
            setScreenProtection(true);
        },
        disableScreenGuard () {
            setScreenProtection(false);
        },
        // Abre o LeaseBlockedModal quando o estado do lease bloqueia playback.
        // Idempotente: se um modal de lease já está aberto, não abre outro.
        maybeOpenLeaseModal (state) {
            const enrollId = this.currentEnroll && this.currentEnroll.id;
            if (!enrollId) return;
            // 'valid' e 'grace' não bloqueiam — banner cobre o grace.
            if (state === 'valid' || state === 'grace') {
                try { this.$modal.hide('lease-blocked'); } catch {}
                return;
            }
            // Só alerta se o enroll ainda tem download REAL (algum LO/turma
            // != 'idle'). Checar só a existência de downloads[enrollId] não
            // basta: ao remover o último download o objeto persiste com filhos
            // 'idle', e o clearLease subsequente leva playableState a 'unknown'
            // — o que faria este modal pipocar logo após a remoção. Sem
            // download não há o que proteger → fecha qualquer modal aberto e sai.
            const ed = this.$store.state.download.downloads[enrollId];
            const hasDownload = !!ed && (
                Object.values(ed.learningObjects || {}).some(s => s !== 'idle') ||
                Object.values(ed.classes || {}).some(s => s !== 'idle')
            );
            if (!hasDownload) {
                try { this.$modal.hide('lease-blocked'); } catch {}
                return;
            }
            this.$modal.show(LeaseBlockedModal, {
                mode: state,
                enrollId,
                onClose: () => this.$modal.hide('lease-blocked'),
            }, {
                name: 'lease-blocked',
                clickToClose: false,
                escToClose: false,
                height: 'auto',
                adaptive: true,
                width: '86%',
                maxWidth: 420,
                classes: 'lease-blocked-wrapper',
            });
        },
        getPDFUrl() {
            // SEMPRE re-aplica as flags de restrição do viewer (lidas pelo
            // public/pdf/viewer.js no init pra esconder os botões de download/
            // seleção). Aplicar antes de qualquer return garante que mesmo no
            // caminho offline + URL local, a restrição do produtor continua
            // valendo. Sem isso, um user que baixou via sidebar sem nunca abrir
            // o PDF online teria localStorage vazio → viewer abriria com
            // botão de download visível, vazando a restrição DRM.
            this._applyPdfViewerRestrictions();

            // Offline + PDF baixado → URL local sempre prevalece. Independe de
            // drmConfig (que pode não ter chegado offline) e do tipo de URL
            // online (autenticada vs pública).
            if (this.isOfflineMode) {
                const enrollId = this.currentEnroll && this.currentEnroll.id;
                const loId = this.currentLearningObject && this.currentLearningObject.id;
                const localUrl = this.getLocalManifestUrl(enrollId, loId);
                if (localUrl) return localUrl;
            }

            if (
                !this.drmConfig ||
                this.drmConfig.codCurso != this.currentEnroll.courseId
            )
                return "";

            if (!this.drmConfig.ativo) return this.currentLearningObject.pdf.url;

            localStorage.setItem("time", AuthService.getAccessToken());
            localStorage.setItem("applicationid", this.currentEnroll.applicationId);

            return this.getAuthPDFUrl();
        },

        // Espelha as flags de restrição do viewer no localStorage. Chamado por
        // getPDFUrl em todos os caminhos (online/offline/com-DRM/sem-DRM) pra
        // o pdf-viewer ler o estado correto. Conservador: quando drmConfig é
        // null ou de outro curso, NÃO mexe nas flags — preserva o que estava
        // setado da última vez online (sticky behavior aceitável e melhor que
        // limpar a restrição em momento de incerteza).
        _applyPdfViewerRestrictions() {
            const cfg = this.drmConfig;
            const cfgMatchesCourse =
                cfg && cfg.codCurso == (this.currentEnroll && this.currentEnroll.courseId);
            if (!cfgMatchesCourse) return;

            localStorage.setItem(
                "desabilitarDownloadVisualizador",
                cfg.desabilitarDownloadVisualizador || isIOSChrome
            );
            localStorage.setItem(
                "desabilitarSelecaoVisualizador",
                cfg.desabilitarSelecaoVisualizador
            );
        },

        getAuthPDFUrl() {
            return (
                process.env.VUE_APP_EAD_API_URL +
                "/courses/" +
                this.currentEnroll.courseId +
                "/learning-obj/" +
                this.currentLearningObject.id +
                "/pdf"
            );
        },

        getAuthFilePDFUrl(fileId) {
            return (
                process.env.VUE_APP_EAD_API_URL +
                "/courses/" +
                this.currentEnroll.courseId +
                "/file/" +
                fileId +
                "/pdf"
            );
        },

        changeColor(e) {
            e.currentTarget.style.color = this.$theme.primaryText;
            e.currentTarget.style.backgroundColor = this.$theme.primaryColor;
            // e.currentTarget.style.borderBottomColor = this.$theme.primaryColor;
            // e.currentTarget.style.borderBottomWidth = "1px";
        },
        changeColorToOriginal(e) {
            if (e.currentTarget.classList.contains("active")) return;
            if (this.$theme.darkTheme) {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.color = "#f2f3f7";
            } else {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.color = "#333333";
            }

            // e.target.style.borderBottomColor = this.$theme.primaryColor;
            // e.target.style.borderBottomWidth = "1px";
        },

        setActive(value, e) {
            this.tabIndex = value;
            if (value != 3) {
                this.subtabIndex = '';
            }

            if (value == 3) {
                // Abre a IA na primeira sub-aba DISPONÍVEL. A Transcrição (4) só
                // existe quando há legenda E ela foi carregada — online pelo
                // player, offline pelo loadOfflineTranscript. Sem transcrição,
                // cai no Resumo (5).
                const transcriptAvailable = this.transcriptionsVisible && this.enableSubtitle;
                if (!this.subtabIndex || (this.subtabIndex == 4 && !transcriptAvailable)) {
                    this.subtabIndex = transcriptAvailable ? 4 : 5;
                }
            }
            var tabs = document.querySelectorAll(".tablink");
            // for (var i = 0; i < tabs.length; i++) tabs[i].removeAttribute("style");
            e.$event.currentTarget.style.backgroundColor = this.$theme.primaryColor;
            e.$event.currentTarget.style.borderBottomColor = this.$theme.primaryColor;
            e.$event.currentTarget.style.borderBottomWidth = "1px";
            e.$event.currentTarget.style.color = this.$theme.primaryText;
        },

        subSetActive(subvalue, e) {
            this.subtabIndex = subvalue;
            var subTabs = document.querySelectorAll(".sub-tablink");
            e.$event.currentTarget.style.backgroundColor = this.$theme.primaryColor;
            e.$event.currentTarget.style.borderBottomColor = this.$theme.primaryColor;
            e.$event.currentTarget.style.borderBottomWidth = "1px";
            e.$event.currentTarget.style.color = this.$theme.primaryText;
        },

        async load() {
            this.loading = true;

            // Resetar o progresso reportado ao carregar nova aula
            this.lastReportedProgress = 0;

            var lastLearningObject = null;

            if (this.currentLearningObject && this.currentLearningObject.broadcast) {
                lastLearningObject = {
                    id: this.currentLearningObject.id,
                    classId: this.currentLearningObject.classId,
                    disciplineId: this.currentLearningObject.disciplineId,
                    moduleId: this.currentLearningObject.moduleId,
                    broadcastId: this.currentLearningObject.broadcast.id,
                };
            }

            if (
                !this.currentEnroll ||
                this.currentEnroll.id != this.$route.params.enrollId
            ) {
                await this.$store.dispatch("enroll/setCurrentEnroll", {
                    enrollId: this.$route.params.enrollId,
                });
            }

            if (!this.currentEnroll) {
                this.loading = false;
                return;
            }

            if (!await this.checkAndShowTermsModal(this.currentEnroll)) return;

            await this.$store.dispatch(
                "enroll/setCurrentLearningObject",
                this.$route.params.id
            );
            // Busca as configurações do curso
          try {
      if (Capacitor.isNativePlatform() && !this.isConnected) throw new Error('offline');
      const settingsResponse = await ConfigService.getCourseSettings(this.currentEnroll.courseId);

      // Se retornar 204 (No Content) ou 200 com data vazio, usa enableIA do enroll
      if (settingsResponse.status === 204 || !settingsResponse.data || settingsResponse.data === '') {
        this.courseSettings = {
          enableChatBot: this.currentEnroll?.settings?.enableIA || false,
          enableIAContent: this.currentEnroll?.settings?.enableIA || false,
          enableSubtitles: this.currentEnroll?.settings?.subtitleType || false
        };
      } else {
        this.courseSettings = {
          enableChatBot: settingsResponse.data.enableChatBot || false,
          enableIAContent: settingsResponse.data.enableIAContent || false,
          enableSubtitles: settingsResponse.data.enableSubtitles || false
        };
      }
      // Guarda o que o servidor disse, pra decidir igual quando não houver rede.
      offlineStorage.saveCourseSettings(this.currentEnroll.courseId, this.courseSettings);
    }  catch (error) {
                console.error('Erro ao buscar configurações do curso:', error);
                // Offline (ou erro de rede): usa o que foi guardado da última vez
                // com rede. Sem esse cache, o fallback assumia a flag do ENROLL —
                // e um curso onde o produtor desligou a IA no nível de CURSO
                // voltava a mostrar a aba offline, exibindo conteúdo que ele tinha
                // desabilitado.
                //
                // Sem nada em cache (nunca abriu essa aula com rede), mantém o
                // fallback antigo: sem ele, enableIAContent/Subtitles ficavam
                // false e a aba sumia mesmo com a IA baixada.
                const cached = offlineStorage.getCourseSettings(this.currentEnroll?.courseId);
                this.courseSettings = cached || {
                    enableChatBot: this.currentEnroll?.settings?.enableIA || false,
                    enableIAContent: this.currentEnroll?.settings?.enableIA || false,
                    enableSubtitles: this.currentEnroll?.settings?.subtitleType || false
                };
            }

            if (this.currentEnroll && this.currentLearningObject) {
                this.$gtag.pageview({
                    page_title:
                        this.currentEnroll.name + " - " + this.currentLearningObject.title,
                    page_path:
                        "/p/course/" +
                        this.currentEnroll.courseId +
                        "/class/" +
                        this.currentLearningObject.id,
                });
            }

            this.loading = false;

            if (this.isDesktop && this.sidenavIsOpen)
                this.$emit("openLeftMenu", this.currentLearningObject.classId);

            if (this.isConnected) {
                this.$store.dispatch("enroll/setLastAccess", {
                    enroll: this.currentEnroll,
                    learningObject: this.currentLearningObject,
                });
            }

            if (
                this.currentLearningObject.pdf ||
                this.currentLearningObject.htmlContent
            ) {
                this.$store.dispatch("enroll/setProgress", {
                    enrollId: this.currentEnroll.id,
                    courseId: this.currentEnroll.courseId,
                    moduleId: this.currentLearningObject.moduleId,
                    disciplineId: this.currentLearningObject.disciplineId,
                    classId: this.currentLearningObject.classId,
                    learningObjectId: this.currentLearningObject.id,
                    broadcastId: this.currentLearningObject.broadcast
                        ? this.currentLearningObject.broadcast.id
                        : null,
                    progress: 100,
                });
            }

            if (this.isConnected) {
                this._commentsLoadedFor = String(this.$route.params.id);
                this.$store.dispatch("comment/getComments", {
                    CourseId: this.$store.state.enroll.current.courseId,
                    LearningObjectId: this.$route.params.id,
                });

                this.$store.dispatch("learningObject/getRatings", {
                    LearningObjectId: this.$route.params.id,
                });
            }

            this.$store.dispatch("learningObject/getAI", {
                LearningObjectId: this.$route.params.id,
            });

            this.loadAudioTranscript();

            if (this.isConnected) {
                await this.$store.dispatch(
                    "learningObject/getDRM",
                    this.currentEnroll.courseId
                );
            }

            if (this.isConnected && lastLearningObject) {
                this.$store.dispatch("enroll/refreshProgress", {
                    enrollId: this.currentEnroll.id,
                    courseId: this.currentEnroll.courseId,
                    moduleId: lastLearningObject.moduleId,
                    disciplineId: lastLearningObject.disciplineId,
                    classId: lastLearningObject.classId,
                    learningObjectId: lastLearningObject.id,
                    broadcastId: lastLearningObject.broadcastId,
                });
                this.$store.dispatch("enroll/getCourseProgress", this.currentEnroll.id);
            }

            this.$nextTick(() => {
                var dropDowns = document.querySelectorAll(".dropdown-trigger");
                M.Dropdown.init(dropDowns, {
                    constrainWidth: false,
                    coverTrigger: false,
                    closeOnClick: false,
                });
            });
        },

        getCurrentClass() {
            const structureType = this.currentEnroll.structureType.toLowerCase();
            var currentClass;
            switch (structureType) {
                case "modulesanddisciplines":
                    //TODO: Nada no layout suporta essa organização
                    break;
                case "modules":
                case "disciplinas":
                    currentClass = this.currentEnroll[structureType].classes.find(
                        (c) => c.id == currentClassId
                    );
                    break;
                case "classes":
                    currentClass = this.currentEnroll.classes.find(
                        (c) => c.id == currentClassId
                    );
                    break;
            }
            return currentClass;
        },
        handleEnded() {
            // Vídeo local (baixado) terminou → marca conclusão. Online o backend
            // recebe a conclusão via vdplayer; mas em playback LOCAL (online ou
            // offline) o vdplayer não é tocado, então marcamos explicitamente.
            if (this.localVideoSrc) this.markLocalVideoComplete();
            // Online a conclusão não passa pelo enroll/setProgress (é o vdplayer
            // que grava), então o pedido contextual de push precisa deste gancho.
            // Duplicado com o do setProgress no vídeo local: o pushPrompt é
            // idempotente (um pedido por gatilho).
            else if (this.$isApp) maybeAskPushPermission(PROMPT_TRIGGERS.LESSON);
            if (this.config.autoNext) {
                this.navigateNextClass(true);
            }
        },
        // Marca a aula de vídeo LOCAL como concluída (setProgress 100). Offline,
        // o setProgress enfileira (flush no reconnect); online, posta direto.
        // Guard por LO: dispara uma vez por aula (handlePlayerTime ≥95% +
        // handleEnded são redundantes de propósito). A fila ainda deduplica por LO.
        markLocalVideoComplete() {
            const lo = this.currentLearningObject;
            if (!lo || this._localCompletionFor === lo.id) return;
            this._localCompletionFor = lo.id;
            this.$store.dispatch('enroll/setProgress', {
                enrollId: this.currentEnroll.id,
                courseId: this.currentEnroll.courseId,
                moduleId: lo.moduleId,
                disciplineId: lo.disciplineId,
                classId: lo.classId,
                learningObjectId: lo.id,
                broadcastId: lo.broadcast ? lo.broadcast.id : null,
                progress: 100,
            });
        },
        // Enfileira a posição offline pro vdplayer (resume cross-device + analytics). Dedup por
        // LO mantém a última. Precisa de position>0 + broadcast + creds webcast + email.
        enqueueOfflineSession(seconds) {
            // Só offline: online o bundle coremedia já reporta a posição ao vdplayer
            // (só pula a telemetria quando localSrc && isOffline) — enfileirar aqui duplicaria.
            if (!this.isOfflineMode) return;
            if (!(seconds > 0)) return;
            const lo = this.currentLearningObject;
            const enroll = this.currentEnroll;
            const broadcastId = lo && lo.broadcast && lo.broadcast.id;
            const webcast = (enroll && enroll.webcastIntegration) || {};
            const email = this.currentUser && this.currentUser.email;
            if (!broadcastId || !webcast.applicationId || !webcast.accessToken || !email) return;
            // 3º arg = dono do evento: a fila sobrevive ao logout e o flush só
            // envia o que pertence ao aluno logado (device compartilhado).
            offlineEventQueue.enqueue(OfflineEventType.OFFLINE_SESSION, {
                learningObjectId: lo.id,
                broadcastId,
                position: seconds,
                watchedAt: new Date().toISOString(),
                customerId: webcast.applicationId,
                token: webcast.accessToken,
                userEmail: email
            }, this.currentUser && this.currentUser.studentId);
        },
        handlePlayerTime(seconds) {
            // Salva position local sempre que está tocando fonte LOCAL
            // (independente de online/offline). Antes o guard era
            // `!isOfflineMode || !localVideoSrc` — i.e., só salvava sem
            // internet. Resultado: aulas baixadas tocadas com app online
            // nunca atualizavam state.positions, então:
            //   - "Continue assistindo" não listava
            //   - DownloadedLearningObjectRow ficava como "não tocada"
            //   - offlineResumePosition voltava 0 quando user ficava offline
            // Quando tocando fonte ONLINE (sem localVideoSrc), o backend
            // recebe progresso via outros handlers (enroll/setProgress);
            // não duplicamos aqui.
            if (!this.localVideoSrc) return;
            // Defesa contra valores inválidos do player (NaN/Infinity vindos
            // de seek mid-buffer, glitch do video.js, etc.). Sem este guard,
            // NaN/negativo poluía state.positions e causava "NaN%" nas barras
            // de progresso de Meus Downloads + isCompleted nunca atingia true.
            if (!Number.isFinite(seconds) || seconds < 0) return;
            if (!this._lastPositionSave || Date.now() - this._lastPositionSave >= 5000) {
                this._lastPositionSave = Date.now();
                const enrollId = this.currentEnroll && this.currentEnroll.id;
                const loId = this.currentLearningObject && this.currentLearningObject.id;
                if (enrollId && loId) {
                    this.$store.commit('download/SET_POSITION', { enrollId, loId, seconds });
                    this.enqueueOfflineSession(seconds);
                }
            }
            // Conclusão de vídeo local ao passar de ~95% (cobre "assistiu quase
            // tudo e fechou", sem depender do evento de fim exato). markLocalVideoComplete
            // é guardado por LO, então não spamma.
            const lo = this.currentLearningObject;
            const duration = (lo && lo.broadcast && lo.broadcast.duration) || 0;
            if (duration > 0 && seconds >= duration * 0.95) {
                this.markLocalVideoComplete();
            }
        },
        // Persiste a posição do áudio BAIXADO (segundos) a cada ~5s → "Continue assistindo"
        // + resume (via :startAt). Áudio não tem broadcast/vdplayer, então é só posição local.
        handleAudioTime(seconds) {
            // Story-2499: mantém a frase corrente destacada na aba Transcrição. No vídeo quem
            // faz isso é o bundle do coremedia, a cada timeupdate do video.js; o player de
            // áudio é nosso, então o despacho sai daqui.
            if (Number.isFinite(seconds)) {
                this.$store.dispatch('transcript/setCurrentPosition', seconds);
            }

            const enrollId = this.currentEnroll && this.currentEnroll.id;
            const loId = this.currentLearningObject && this.currentLearningObject.id;
            if (!enrollId || !loId) return;
            if (this.getLearningObjectStatus(enrollId, loId) !== 'downloaded') return;
            if (!Number.isFinite(seconds) || seconds < 0) return;
            if (!this._lastAudioPositionSave || Date.now() - this._lastAudioPositionSave >= 5000) {
                this._lastAudioPositionSave = Date.now();
                this.$store.commit('download/SET_POSITION', { enrollId, loId, seconds });
            }
        },
        async handleAudioProgress(progressPercent) {
            // Atualizar progresso a cada 10% para evitar muitas chamadas
            const roundedProgress = Math.floor(progressPercent / 10) * 10;

            if (roundedProgress > this.lastReportedProgress && roundedProgress < 100) {
                this.lastReportedProgress = roundedProgress;

                await this.$store.dispatch("enroll/setProgress", {
                    enrollId: this.currentEnroll.id,
                    courseId: this.currentEnroll.courseId,
                    moduleId: this.currentLearningObject.moduleId,
                    disciplineId: this.currentLearningObject.disciplineId,
                    classId: this.currentLearningObject.classId,
                    learningObjectId: this.currentLearningObject.id,
                    broadcastId: this.currentLearningObject.broadcast
                        ? this.currentLearningObject.broadcast.id
                        : null,
                    progress: roundedProgress,
                });
            }
        },
        async handleAudioComplete(progress) {
            // Registrar 100% de progresso e marcar como concluído
            await this.$store.dispatch("enroll/setProgress", {
                enrollId: this.currentEnroll.id,
                courseId: this.currentEnroll.courseId,
                moduleId: this.currentLearningObject.moduleId,
                disciplineId: this.currentLearningObject.disciplineId,
                classId: this.currentLearningObject.classId,
                learningObjectId: this.currentLearningObject.id,
                broadcastId: this.currentLearningObject.broadcast
                    ? this.currentLearningObject.broadcast.id
                    : null,
                progress: 100,
            });

            // Atualizar o progresso geral do curso
            this.$store.dispatch("enroll/getCourseProgress", this.currentEnroll.id);

            this.lastReportedProgress = 100;
        },
        coremediaReady(event) {
            this.transcriptionsVisible = event.HasSubtitles;
            //event.IsVideoJs: bool
            //event.IsVidemo: bool

            // Offline o bundle monta um broadcast stub com `subtitles: []`, então
            // HasSubtitles é sempre false e a aba nunca apareceria. A transcrição
            // já foi baixada no download (prefetchTranscript → saveTranscript);
            // aqui ela é lida do disco e injetada no mesmo módulo que o caminho
            // online usa. O highlight acompanha o vídeo sem mais nada: o player
            // já despacha transcript/setCurrentPosition a cada timeupdate.
            if (this.isOfflineMode) this.loadOfflineTranscript();
        },

        /**
         * Story-2499: carrega a transcrição de uma aula de áudio.
         *
         * O equivalente do que o bundle coremedia faz sozinho no vídeo — só que o áudio não
         * tem player do coremedia nem broadcastId, então a transcrição vem do EAD como
         * WebVTT e é convertida aqui para o mesmo formato de frases que a aba consome.
         *
         * Também é o que liga transcriptionsVisible no áudio: no vídeo isso vem do evento
         * @ready do coremedia-player, que nunca dispara aqui.
         *
         * Silencioso em caso de falha: a transcrição é um extra da aula, e o áudio continua
         * tocando sem ela.
         */
        /**
         * Posiciona e toca o player de áudio. Sai em silêncio se o ref ainda não montou —
         * nunca cai no vdplayer, que numa aula de áudio seria o player da aula anterior.
         */
        seekAudioPlayer(seconds) {
            const player = this.$refs.audioPlayer;
            if (!player) return;

            player.play();
            player.seek(seconds);
        },

        async loadAudioTranscript() {
            const lo = this.currentLearningObject;

            // Aula que não é de áudio limpa o store antes de sair. O módulo transcript é
            // singleton e transcriptionsVisible só é redefinido pelo @ready do coremedia:
            // sem esta limpeza, ao sair de um áudio para um vídeo a aba continuaria
            // exibindo as frases da aula anterior até o player ficar ready — ou para
            // sempre, se ele nunca ficar.
            if (!lo || !lo.audio) {
                this.$store.commit('transcript/setTranscript', { frases: [] });
                this.transcriptionsVisible = false;
                return;
            }

            const loId = lo.id;

            try {
                const data = await this.$store.dispatch('learningObject/getSubtitle', loId);

                // Guard de corrida, igual ao do loadOfflineTranscript: o aluno pode ter
                // trocado de aula enquanto a requisição resolvia.
                if (!this.currentLearningObject || this.currentLearningObject.id !== loId) return;

                const frases = parseWebVtt(data && data.subtitle);

                // Commita mesmo vazio: o módulo transcript é singleton e manteria as frases
                // da aula anterior.
                this.$store.commit('transcript/setTranscript', { frases });
                this.transcriptionsVisible = frases.length > 0;
            } catch (e) {
                console.warn('[transcript] transcrição do áudio indisponível:', e?.message || e);
                this.$store.commit('transcript/setTranscript', { frases: [] });
                this.transcriptionsVisible = false;
            }
        },

        async loadOfflineTranscript() {
            const loId = this.currentLearningObject && this.currentLearningObject.id;
            if (!loId) return;
            try {
                const data = await offlineStorage.getTranscript(loId);
                // Guard de corrida: o user pode ter trocado de aula enquanto o
                // read do disco resolvia — não injeta transcrição da aula errada.
                if (!this.currentLearningObject || this.currentLearningObject.id !== loId) return;

                const frases = data && Array.isArray(data.frases) ? data.frases : [];
                // Commita mesmo vazio: o módulo transcript é singleton no store
                // compartilhado e manteria as frases da aula ANTERIOR. A aba fica
                // escondida (transcriptionsVisible false), mas não deixamos dado
                // velho pendurado no state.
                this.$store.commit('transcript/setTranscript', { frases });
                this.transcriptionsVisible = frases.length > 0;
            } catch (e) {
                console.warn('[transcript] leitura offline falhou:', e?.message || e);
            }
        },
        navigatePreviousClass() {
            if (!this.currentLearningObject.previousId) return;

            this.$router.push({
                name: "class",
                params: {
                    enrollId: this.currentEnroll.id,
                    id: this.currentLearningObject.previousId,
                },
            });
        },
        navigateNextClass(auto) {
            if (!this.currentLearningObject.nextId) return;

            var routerParams = {
                name: "class",
                params: {
                    enrollId: this.currentEnroll.id,
                    id: this.currentLearningObject.nextId,
                },
            };
            if (auto) routerParams.query = { time: 0 }; //pq não funciona 0?

            this.$router.push(routerParams);
        },
        navigateToClass(eventData) {
            this.$router.push({
                name: "class",
                params: { enrollId: this.currentEnroll.id, id: eventData.id },
            });
        },
        async navigateToClassFromBubble(eventData) {
            try {
                let enrollId = null;
                const learningObjectId = +eventData.detail.source.custom_id;

                if (!this.currentEnroll.shopWindowId) {
                    if (!this.learningObjects?.some((learningObject) => learningObject.id === learningObjectId)) {
                        throw new Error("Learning Object doesn't belong to this course");
                    }

                    enrollId = this.currentEnroll.id;
                } else {
                    if (!this.learningObjectsEnrolls.length)
                        await this.$store.dispatch(
                            "shopWindow/getLearningObjectsEnrolls",
                            this.$currentUser.studentId
                        );

                    var learningObjectsEnrolls = this.learningObjectsEnrolls;
                    const learningObject =
                        learningObjectsEnrolls &&
                        learningObjectsEnrolls.find(
                            (obj) => obj.learningObjectId === learningObjectId
                        );
                    if (learningObject) {
                        enrollId = learningObject.enrollId;
                    }
                }

                await this.$router.push({
                    name: "class",
                    params: {
                        enrollId: enrollId,
                        id: learningObjectId,
                    },
                });
                window.minimizeChatBot();
            } catch (error) {
                console.error(error);
                this.$store.commit("toast/NEW", {
                    type: "warn",
                    message: "Ops! Não foi possível navegar para esta aula.",
                });
            }
        },
        async setProgress() {
            await this.$store.dispatch("enroll/setProgress", {
                enrollId: this.currentEnroll.id,
                courseId: this.currentEnroll.courseId,
                moduleId: this.currentLearningObject.moduleId,
                disciplineId: this.currentLearningObject.disciplineId,
                classId: this.currentLearningObject.classId,
                learningObjectId: this.currentLearningObject.id,
                broadcastId: this.currentLearningObject.broadcast
                    ? this.currentLearningObject.broadcast.id
                    : null,
                progress: this.currentLearningObject.progress < 100 ? 100 : 0,
            });
            if (this.isConnected) {
                this.$store.dispatch("enroll/getCourseProgress", this.currentEnroll.id);
            }
        },

        async downloadLearningObjectFile() {
            var fileName = "Aula_" + this.currentLearningObject.id;
            var options = {
                url: '',
                name: fileName,
                filename: fileName + ".pdf"
            };
            options.headers = {
                authorization: "bearer " + AuthService.getAccessToken(),
                "x-applicationid": this.currentEnroll.applicationId,
            };

            options.url = await this.$store.dispatch(
            "learningObject/getFileLearningObjectAuth",
            {
                courseId: this.currentEnroll.courseId,
                learningObjectId: this.currentLearningObject.id,
            })

            window.open(options.url, "_blank").focus();
        },
        scrollToFiles() {
            const el = this.$refs.lessonFiles;
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        },
        fileTypeColor(type) {
            const t = (type || "").toLowerCase();
            if (t === "pdf") return "#e5484d";
            if (["xls", "xlsx", "csv"].includes(t)) return "#1f9d55";
            if (["doc", "docx", "txt", "rtf"].includes(t)) return "#2f6fdf";
            if (["ppt", "pptx", "key"].includes(t)) return "#e0662b";
            if (["zip", "rar", "7z"].includes(t)) return "#c98500";
            if (["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(t)) return "#8e4ec6";
            if (["mp3", "wav", "m4a", "mp4", "mov"].includes(t)) return "#0f9bb0";
            return "#6b7280";
        },
        async downloadFile(file, i, currentLearningObject, el) {
            if (file.generatedItemLink || file.loadingItem) return;

            this.$store.dispatch("enroll/updateLoadingFile", {
                i: i,
                value: true,
            });

            this.$nextTick(async () => {
                var options = {
                    url: file.url,
                    name: file.name,
                    filename: file.name + "." + file.fileType,
                    size: file.size,
                };

                if (file.url.indexOf(".pdf") > -1 && this.drmConfig.ativo) {
                    options.headers = {
                        authorization: "bearer " + AuthService.getAccessToken(),
                        "x-applicationid": this.currentEnroll.applicationId,
                    };

                    options.url =
                        process.env.VUE_APP_EAD_API_URL +
                        "/courses/" +
                        this.currentEnroll.courseId +
                        "/file/" +
                        file.id +
                        "/pdf";
                }

                if (file.url.indexOf(".pdf") > -1 && this.drmConfig.abrirNavegador) {
                    if (this.drmConfig.ativo) {
                        options.url = await this.$store.dispatch(
                            "learningObject/getDMRAuth",
                            {
                                courseId: this.currentEnroll.courseId,
                                fileId: file.id,
                            }
                        );
                    }

                    this.$store.dispatch("enroll/updateLoadingFile", {
                        i: i,
                        value: false,
                    });

                    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                        document.location = options.url;
                        return;
                    }

                    window.open(options.url, "_blank").focus();
                    return;
                }

                /*
                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {

                  this.$store.dispatch("enroll/updateLoadingFile", {
                    i: i,
                    value: false,
                  });

                  if(this.drmConfig.ativo && file.url.indexOf('.pdf') > -1 )
                  {
                    this.loading = true;

                    options.url = await this.$store.dispatch("learningObject/getDMRAuth", {
                      courseId:this.currentEnroll.courseId,
                      fileId:file.id
                    });

                    this.loading = false;
                  }

                  // document.location = options.url;

                  // var windowReference = window.open();
                  // windowReference.location = options.url;

                  // window.open(options.url, '_blank').focus();
                  // return;
                }
                // */

                var downloader = new Downloader();
                this.activeDownloads.push({ fileName: file.name, progress: 0 });
                downloader.onprogress = this.downloadProgress;
                downloader.onfinished = (filename) => {
                    this.$store.dispatch("enroll/updateLoadingFile", {
                        i: i,
                        value: false,
                    });
                    this.downloadFinished(filename);
                };

                if (options.url.indexOf(".pdf") > -1 && this.drmConfig.ativo) {
                    options.headers = {
                        authorization: "bearer " + AuthService.getAccessToken(),
                        "x-applicationid": this.currentEnroll.applicationId,
                    };

                    var fileId = fileUrl.split("/").pop().split(".")[0];
                    options.url = this.getAuthFilePDFUrl(fileId);
                }

                downloader.download(options);
            });
        },

        openTab(url) {
            // Create link in memory
            var a = window.document.createElement("a");
            a.target = "_blank";
            a.href = url;

            // Dispatch fake click
            var e = window.document.createEvent("MouseEvents");
            e.initMouseEvent(
                "click",
                true,
                true,
                window,
                0,
                0,
                0,
                0,
                0,
                false,
                false,
                false,
                false,
                0,
                null
            );
            a.dispatchEvent(e);
        },

        downloadProgress(evt) {
            for (var i = 0; i < this.activeDownloads.length; i++) {
                if (this.activeDownloads[i].fileName == evt.filename) {
                    this.activeDownloads[i].progress = evt.progress;
                    break;
                }
            }
        },
        isDownloading() {
            return this.activeDownloads.length > 0;
        },
        progressPercent(file) {
            if (!file) return;
            const activeDownload = this.activeDownloads.filter((ad) => {
                return ad.fileName == file.name;
            })[0];
            if (activeDownload) return activeDownload.progress + "%";
            return;
        },
        downloadFinished(filename) {
            for (var i = 0; i < this.activeDownloads.length; i++) {
                if (this.activeDownloads[i].fileName == filename) {
                    this.activeDownloads.splice(i, 1);
                    break;
                }
            }
        },

        debounceSearch(value, updateHandler) {
            clearTimeout(this.searchTimeout);
            this.searchQuery = value;

            this.searchTimeout = setTimeout(() => {
                updateHandler(this.searchQuery);
            }, 300);
        },
        handleTranscriptSelectedChange(index) {
            var lis = this.$refs.transcripts.querySelectorAll("li");

            this.$refs.transcripts.scrollTop =
                lis[index].offsetTop -
                this.$refs.transcripts.offsetTop -
                this.$refs.transcripts.clientHeight / 1.8;
        },
        handleSearchResultChanged(indexes) {
            var lis = this.$refs.transcripts.querySelectorAll("li");

            if (!indexes) return;

            var index = indexes.phraseIndex;
            this.$refs.transcripts.scrollTop =
                lis[index].offsetTop -
                this.$refs.transcripts.offsetTop -
                this.$refs.transcripts.clientHeight / 1.8;
        },
        isCompressed() {
            return this.sidenavIsOpen;
        },
        playAndSeek(begin, seek) {
            if (begin) {
                try {
                    // Story-2499: window.vdplayer é global do bundle coremedia e só existe em
                    // aula de vídeo. No áudio o seek vai pelo nosso player, senão clicar numa
                    // frase da transcrição não faz absolutamente nada.
                    if (this.isAudioLesson) {
                        this.seekAudioPlayer(begin);
                        return;
                    }

                    if (!window.vdplayer) return;
                    vdplayer.play();
                    vdplayer.seekTo(begin);
                } catch (error) {
                    console.error(error);
                }
            }
        },
        // Abre a aba de comentários e, com id, rola até o comentário e o destaca. O hash
        // sai da URL na hora (como o de tempo): voltar para a aula não repete o foco.
        focusComments(commentId) {
            this.commentFocus = { id: commentId, tries: 0, commentsArrived: false };
            this.$router.replace({ hash: "" }).catch(() => {});
            this.refreshCommentsIfLoaded();
            this.tryFocusComment();
        },
        // Push ou sino que abre a aula JÁ aberta: só o hash muda, a aula não recarrega e
        // a lista na tela é de antes da resposta. Busca de novo; o watcher da lista segue
        // o foco. Aula entrando agora não precisa: o load() já busca.
        refreshCommentsIfLoaded() {
            const loId = String(this.$route.params.id);
            const enroll = this.$store.state.enroll.current;
            if (!this.isConnected || !enroll || this._commentsLoadedFor !== loId) return;
            this.$store.dispatch("comment/getComments", {
                CourseId: enroll.courseId,
                LearningObjectId: loId,
            });
        },
        tryFocusComment() {
            const focus = this.commentFocus;
            if (!focus) return;
            clearTimeout(this._commentFocusTimer);
            if (!this.enableComments) {
                // Configuração do curso ainda carregando, ou comentários desligados no curso.
                if (++focus.tries > COMMENT_FOCUS_MAX_TRIES) this.commentFocus = null;
                else this._commentFocusTimer = setTimeout(this.tryFocusComment, COMMENT_FOCUS_RETRY_MS);
                return;
            }
            this.tabIndex = 2;
            this.$nextTick(() => {
                if (this.commentFocus !== focus) return;
                const el = focus.id ? document.getElementById(`comentario-${focus.id}`) : null;
                if (el) {
                    this.commentFocus = null;
                    el.scrollIntoView({ behavior: "smooth", block: "center" });
                    el.classList.add("comment-highlight");
                    setTimeout(() => el.classList.remove("comment-highlight"), 2600);
                    return;
                }
                // Rolar antes de a lista chegar não adianta: a aula ainda está montando e a
                // tela volta para o topo. Com id, espera o comentário aparecer; sem id (sino),
                // espera a lista chegar ou ~1,2 s (a lista pode já estar carregada).
                const maxTries = focus.id ? COMMENT_FOCUS_MAX_TRIES : COMMENT_TAB_MAX_TRIES;
                const waitingList = !focus.id && !focus.commentsArrived;
                if ((focus.id || waitingList) && ++focus.tries <= maxTries) {
                    this._commentFocusTimer = setTimeout(this.tryFocusComment, COMMENT_FOCUS_RETRY_MS);
                    return;
                }
                // Sem id, ou o comentário não apareceu (reprovado, apagado): a aba no topo da
                // tela, com a lista logo abaixo.
                this.commentFocus = null;
                const tabs = this.$refs.lessonTabs;
                if (tabs) tabs.scrollIntoView({ behavior: "smooth", block: "start" });
            });
        },
        seekToTime(timeHash) {
            if (timeHash) {
                try {
                    const time = timeHash.replace("#", "");
                    const seekTime = timeSpanToMs(time) / 1000;

                    // Story-2499: deep-link com hash de tempo também funciona em áudio.
                    if (this.isAudioLesson) {
                        this.seekAudioPlayer(seekTime);
                        return;
                    }

                    if (!window.vdplayer) return;
                    vdplayer.play();
                    vdplayer.seekTo(seekTime);
                } catch (error) {
                } finally {
                    this.$router.replace({ hash: "" });
                }
            }
        },
        async enableChatBot() {
            // Verifica primeiro se o chatbot está habilitado nas configurações do curso
            if (!this.courseSettings.enableChatBot) return;
            // Verifica se o curso tem um agentId configurado
            if (!this.currentEnroll?.agentId) return;
            var agentImage = this.currentEnroll.agentImage;
            if (agentImage && !agentImage.startsWith("http")) {
                agentImage = `${process.env.VUE_APP_CDN_URL}` + agentImage;
            }
            await window.enableChatBot(
                this.currentEnroll.agentId,
                agentImage,
                this.currentEnroll.enableHumanSupport,
                this.currentEnroll.humanSupportOptions,
                this.currentEnroll.humanSupportMessage,
                this.currentEnroll.id,
                this.$currentUser,
                null,
                this.$profilePic
            );
        },
    },
    filters: {
        bytes: function (bytes) {
            if (bytes > 1048576) {
                return (bytes / 1024 / 1024).toFixed(1) + "MB";
            } else {
                return (bytes / 1024).toFixed(1) + "KB";
            }
        },
        formatTimestamp,
    },
};
</script>
<style scoped lang="scss">
.offline-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin: 0 auto 8px;
    padding: 4px 12px;
    border: 1px solid;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;

    i {
        font-size: 16px;
    }

    &--light {
        background: rgba(0, 0, 0, 0.04);
    }

    &--dark {
        background: rgba(255, 255, 255, 0.06);
    }
}

.aiTitle {
    padding-top: 25px;
    font-weight: bold;
    border-bottom: 1px solid var(--primary-color);
}

.aiContent {
    word-wrap: break-word;
    padding: 20px;
    white-space: break-spaces;
}

.btn-info {
    width: 100%;
    height: 35px;
    display: flex;
    gap: 8px;
    /* Deep link para os comentários rola até aqui: o cabeçalho fixo não cobre as abas. */
    scroll-margin-top: calc(env(safe-area-inset-top, 0px) + 72px);

    .tablink {
        flex: 0 0 auto;
        width: auto;
        margin: 0;
    }
}

#btn-ia {
  width: fit-content;
  margin-left: auto;
}

@media only screen and (min-width: 993px) {
    .player {
        position: relative;
        width: 70%;
        margin: 0 auto;
        max-width: 148vh;
        border-radius: 5px;
        overflow: hidden;
    }
}

.menu-previous.disabled,
.menu-next.disabled {
    color: #666;
}

.dropdown-content li {
    min-height: auto;
    border-top: solid 1px #333;
}

.dropdown-content,
.dropdown-content li>a,
.dropdown-content li>span {
    background: #222;
    border-radius: 5px;
    font-family: Roboto;
    font-size: 12px;
}

.pdf-navigation-goto {
    font-family: Montserrat;
    font-size: 13px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #bfbfbf;
}

.pdf-nav-previous,
.pdf-nav-next {
    background: none;
}

.box-info .tabcontent-text {
    word-break: break-word;
}

.transcripts {
    height: 300px;
    overflow-y: auto;
    padding-right: 1em;

    @media screen and (max-width: 640px) {
        padding-left: 0.5em !important;
    }
}

.transcripts li.segment {
    list-style: none !important;
    display: flex;
    align-items: baseline;
    padding: 8px 16px;
    border-radius: 4px;
    transition: background ease-in-out 50ms;
}

.transcripts li:hover {
    cursor: pointer;
}

.transcripts li {

    &.current,
    &:hover {
        background: rgb(255, 255, 255, 0.2);

        .segment-text {
            font-weight: 600;
        }

        .segment-timestamp {
            opacity: 1;
        }
    }
}

.transcripts.light li {

    &.current,
    &:hover {
        background: rgb(0, 0, 0, 0.05);

        .segment-text {
            font-weight: 500;
        }
    }
}

.transcripts li .filtered {
    background: #bbbbbb;
    color: #000;
}

.transcripts.light li .filtered {
    background: #bbbbbb;
    color: #000000;
}

.transcripts li .filtered.highlight {
    background: #0564b1;
    color: #fff;
    font-weight: 500;
}

.flex-right
{
    padding: 10px 0px;
    display: flex;
    justify-content: end;
}

.transcripts li .segment-timestamp {
    color: var(--primary-text);
    background-color: var(--primary-color);

    flex-basis: 44px;
    flex-shrink: 0;
    padding: 0 4px;
    margin-right: 16px;
    border-radius: 4px;
    opacity: 0.8;
    white-space: nowrap;
    text-align: center;
    user-select: none;
}

.download-progress {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 0;
    background: rgba(255, 255, 255, 0.1);
    transition: width 0.5s;
}

@media screen and (max-width: 680px) {
    .transcripts li.segment {
        padding-inline: 8px;

        .segment-timestamp {
            margin-right: 12px;
        }
    }
}

@media only screen and (min-width: 993px) {
    .box-menu-navigation {
        display: none !important;
    }
}

.files-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    margin-left: 6px;
    border-radius: 999px;
    font-size: 11px;
    line-height: 1;
}

.lesson-files {
    margin-bottom: 32px;

    .lesson-files-head {
        display: flex;
        align-items: baseline;
        gap: 8px;
        margin-bottom: 12px;
    }

    .lesson-files-title {
        font-family: Roboto;
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
    }

    .lesson-files-count {
        font-family: Roboto;
        font-size: 13px;
        color: #8a8f9b;
    }

    .lesson-files-chips {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }
}

.file-chip {
    position: relative;
    overflow: hidden;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    max-width: 100%;
    min-height: 36px;
    padding: 5px 14px 5px 5px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.06);
    color: #ffffff;
    font-family: Roboto;
    font-size: 13px;
    text-align: left;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;

    &:hover,
    &:focus-visible {
        background: rgba(255, 255, 255, 0.12);
        border-color: rgba(255, 255, 255, 0.3);
    }

    &:focus-visible {
        outline: 2px solid rgba(255, 255, 255, 0.6);
        outline-offset: 2px;
    }

    &:disabled {
        cursor: progress;
    }

    &--light {
        background: #f2f3f7;
        border-color: #e1e3ea;
        color: #131318;

        &:hover,
        &:focus-visible {
            background: #e8eaf0;
            border-color: #c9ccd6;
        }

        .file-chip-meta {
            color: #6d7280;
        }
    }

    .file-chip-type {
        flex: none;
        padding: 4px 7px;
        border-radius: 999px;
        color: #ffffff;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.02em;
    }

    .file-chip-name {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .file-chip-meta {
        flex: none;
        font-style: normal;
        font-size: 11px;
        color: #a9adb8;
        font-variant-numeric: tabular-nums;
    }

    .file-chip-progress {
        position: absolute;
        left: 0;
        bottom: 0;
        height: 2px;
        transition: width 0.2s linear;
    }
}

@media only screen and (max-width: 600px) {
    .file-chip {
        min-height: 44px;
        width: 100%;
    }

    .file-chip .file-chip-meta {
        margin-left: auto;
    }
}
</style>
